import {
  FORMATTED_DIRECT_CREMATION_DELIVERY_PRICE,
  FORMATTED_DIRECT_CREMATION_PRICE,
} from 'views/cremation/shared/constants'

const data = {
  title: `Everything you need, from ${FORMATTED_DIRECT_CREMATION_PRICE}.`,
  title2: 'With specialist support throughout.',
  steps: [
    {
      title: 'We arrange the cremation',
      description:
        'Wherever you are in England and Wales, we’ll bring your loved one to our chapel of rest. Then complete all the paperwork and arrange the cremation.',
      illustration: 'funeral-coordinator',
    },
    {
      title: 'On the day',
      description:
        'We’ll transport them to a local crematorium and carry out a cremation you don’t attend. We’re always available if you need a chat.',
      illustration: 'chapel-of-rest',
    },
    {
      title: 'After the cremation',
      description: `We can scatter the ashes, you can collect them from the crematorium, or we can hand-deliver the ashes to you, anywhere in the UK, for ${FORMATTED_DIRECT_CREMATION_DELIVERY_PRICE}.`,
      illustration: 'direct-cremation',
    },
  ],
  ctaLink: {
    text: 'Get a quote now',
  },
}

export default data
